import faIR from 'dayjs/locale/fa';

export default { ...faIR, weekdaysShort: 'یک_دو_سه_چهار_پنج_جم_شن'.split('_') };
